const FONT_CSS = "https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap";

const toDataUrl = (blob) =>
  new Promise((resolve) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.readAsDataURL(blob);
  });

async function embeddedFontCss() {
  try {
    let css = await (await fetch(FONT_CSS)).text();
    const urls = [...new Set(css.match(/https:[^)]+\.woff2/g) || [])];
    for (const u of urls) {
      const data = await toDataUrl(await (await fetch(u)).blob());
      css = css.split(u).join(data);
    }
    return css;
  } catch {
    return "";
  }
}

export async function downloadSvgAsPng(svg, title, filename) {
  const clone = svg.cloneNode(true);
  clone.querySelectorAll(".vsm-arrow").forEach((el) => el.remove());
  const [, , w, h] = clone.getAttribute("viewBox").split(" ").map(Number);
  const ns = "http://www.w3.org/2000/svg";
  clone.setAttribute("xmlns", ns);
  clone.setAttribute("width", w);
  clone.setAttribute("height", h);
  const style = document.createElementNS(ns, "style");
  style.textContent = `${await embeddedFontCss()} .font-grotesk{font-family:"Space Grotesk",sans-serif}.font-mono{font-family:"JetBrains Mono",monospace}`;
  clone.insertBefore(style, clone.firstChild);
  const bg = document.createElementNS(ns, "rect");
  bg.setAttribute("width", w);
  bg.setAttribute("height", h);
  bg.setAttribute("fill", "#fff");
  clone.insertBefore(bg, style.nextSibling);
  const t = document.createElementNS(ns, "text");
  Object.entries({ x: 24, y: 40, "font-size": 22, "font-weight": 700, fill: "#09090b", class: "font-grotesk" }).forEach(([k, v]) => t.setAttribute(k, v));
  t.textContent = title;
  clone.appendChild(t);

  const src = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(clone)], { type: "image/svg+xml;charset=utf-8" }));
  const img = new Image();
  await new Promise((resolve, reject) => {
    img.onload = resolve;
    img.onerror = reject;
    img.src = src;
  });
  const scale = 2;
  const canvas = document.createElement("canvas");
  canvas.width = w * scale;
  canvas.height = h * scale;
  const ctx = canvas.getContext("2d");
  ctx.scale(scale, scale);
  ctx.drawImage(img, 0, 0, w, h);
  URL.revokeObjectURL(src);
  const a = document.createElement("a");
  a.href = canvas.toDataURL("image/png");
  a.download = filename;
  a.click();
}
